import axios from "axios";
import AuthAPI from "./auth";

export default class UserAPI {
  /**
   * @type {axios}
   */
  #client;

  /**
   * @type {AuthAPI}
   */
  #auth;
  constructor(client, authApi) {
    this.#client = client;
    this.#auth = authApi;
  }

  async getMe() {
    try {
      const result = await this.#client.get("/user/@me");
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      try {
        const refreshTry = await this.#auth.refresh();
        if (refreshTry) {
          const result = await this.#client.get("/user/@me");
          if (result.data && result.data.ok) return result.data.data;
          else if (result.data && !result.data.ok) return result.data.error;
        }
      } catch (error) {
        return false;
      }
    }
  }

  async getMyChatrooms() {
    try {
      const result = await this.#client.get("/user/@me/chatrooms");
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async createChatroom() {
    try {
      const result = await this.#client.post("/user/@me/chatrooms/create");
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }
}
